
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.89.35c.73 0 1.434.282 1.963.787a2.778 2.778 0 010 3.927L31.38 6.538a.694.694 0 01-.982 0l-2.946-2.946a.694.694 0 010-.982l1.474-1.473A2.844 2.844 0 0130.89.35zm-3.762 16.346a1.39 1.39 0 012.371.982v11.805a4.167 4.167 0 01-4.166 4.166H4.5a4.166 4.166 0 01-4.167-4.166V5.873a4.166 4.166 0 014.167-4.167h13.888a1.389 1.389 0 110 2.778H4.5a1.389 1.389 0 00-1.39 1.389v23.61a1.389 1.389 0 001.39 1.388h20.832a1.389 1.389 0 001.389-1.388V17.678c0-.369.146-.722.406-.982zm-11.018-1.76l2.945 2.946a.694.694 0 00.982 0l8.839-8.839a.694.694 0 000-.983l-2.947-2.947a.717.717 0 00-.982 0l-8.837 8.841a.694.694 0 000 .982zm-1.707 1.147a.693.693 0 01.93.044l2.53 2.526a.694.694 0 01-.234 1.136l-4.208 1.683a.735.735 0 01-.749-.154.694.694 0 01-.154-.749l1.683-4.215a.701.701 0 01.202-.27z","fill":"#BE2C44"}})])
          )
        }
      }
    